export default __webpack_public_path__ + "static/media/c002-pic.7e754bc5.png";